/**
 * Permission constants
 *
 * This file is generated from the backend permissions system.
 * To update: the permissions are loaded dynamically on app initialization
 * and made available through the usePermissions hook.
 *
 * These constants provide type safety and autocomplete for permission checks.
 */

export interface Permission {
  code: string;
  label: string;
  description: string;
  group: string;
}

/**
 * All available permissions in the system
 * Populated on app initialization from /permissions/permissions endpoint
 */
export let AVAILABLE_PERMISSIONS: Permission[] = [];

/**
 * Permission codes as typed constants for autocomplete
 * Populated on app initialization
 */
export const PERMISSIONS = {} as Record<string, string>;

/**
 * Initialize permissions from backend
 * Called once on app startup
 */
export const initializePermissions = (permissions: Permission[]) => {
  AVAILABLE_PERMISSIONS = permissions;

  // Create typed constants object
  permissions.forEach(permission => {
    // Convert code to constant name: CapacityManagement.People.ReadAll -> PEOPLE_READ_ALL
    const withoutPrefix = permission.code.replace(/^CapacityManagement\./, '');

    // Convert CamelCase to SNAKE_CASE: ReadAll -> READ_ALL
    const snakeCase = withoutPrefix.replace(/([a-z])([A-Z])/g, '$1_$2');

    // Replace dots with underscores and uppercase
    const constantName = snakeCase.replace(/\./g, '_').toUpperCase();

    (PERMISSIONS as Record<string, string>)[constantName] = permission.code;
  });
};

/**
 * Get permission by code
 */
export const getPermission = (code: string): Permission | undefined => {
  return AVAILABLE_PERMISSIONS.find(p => p.code === code);
};

/**
 * Get permissions by group
 */
export const getPermissionsByGroup = (group: string): Permission[] => {
  return AVAILABLE_PERMISSIONS.filter(p => p.group === group);
};
